/**
 * Mobile edition – entry point. Standalone (no queue, the server only keeps the highscore of all phones),
 * same game core and assets as the projection edition. Touch = flap.
 */
import { createGame, pipeSideFor, skylineFor } from '../../game-core/src/index.js';
import { BestScore } from './bestScore.js';
import { GlobalScores } from './globalScores.js';
import { MobileHudScene } from './scenes/MobileHudScene.js';
import { mobileGameSize } from './viewport.js';

const q = new URLSearchParams(location.search);
const { width, height } = mobileGameSize();

const hud = new MobileHudScene(new BestScore(), new GlobalScores());
createGame({
  parent: 'game',
  width,
  height,
  backgroundColor: '#1f68dc',
  renderer: (q.get('renderer') as 'auto' | 'webgl' | 'canvas' | null) ?? 'auto',
  overlays: [hud],
  // ?location=berlin (link shared from the facade): the skyline and columns of that city
  playfield: { skyline: skylineFor(q.get('location')), pipeSide: pipeSideFor(q.get('location')) },
  // two fingers: a second tap while the first finger is still down must flap too
  phaserConfig: { input: { activePointers: 2 } },
});
